import NoPermissionsModal from './NoPermissionsModal';

export default NoPermissionsModal;
